module.exports = __webpack_public_path__ + "static/media/seo-circle.21b3a473.svg";